import { DateFormatter } from '@repo/toolkit/date'

import {
  MissionTrackingReminder,
  StaffReminder,
  StaffReminderHistory
} from '../../types/models/staff/staff-reminder'

/** "R3 - 13/10/2026", with `wrap` the non-breaking space keeps "R3" whole when the badge wraps */
export const getStaffReminderLabel = (reminder: StaffReminder, wrap = false): string =>
  `R${reminder.index}${wrap ? ' ' : ' '}- ${DateFormatter.DDMMYYYY(reminder.sentAt)}`

/** Friendly reminders are grey, final reminders are red */
export const getStaffReminderVariant = (reminder: StaffReminder): 'danger' | 'grey' =>
  reminder.isFinal ? 'danger' : 'grey'

export const getStaffReminderTypeLabel = (reminder: StaffReminder): string =>
  reminder.isFinal ? 'Dernière relance' : 'Relance amicale'

/** Login of the LEC user who sent the reminder, "-" when unknown */
export const getMissionTrackingReminderSenderLabel = (reminder: MissionTrackingReminder): string =>
  reminder.sentBy ?? '-'

/** "Auto" for a cron reminder, the login of the LEC user for a CTA one, "-" when unknown */
export const getStaffReminderSenderLabel = (reminder: StaffReminderHistory): string => {
  if (reminder.isAutomatic) return 'Auto'
  return reminder.sentBy ?? '-'
}
